import MapInitialParameters from './MapInitialParameters';

export default MapInitialParameters;
